import React, { Component, Fragment } from "react";
import { Divider, Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { getValue } from "../utils/models";

class Driver extends Component {
  render() {
    return (
      <Fragment>
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"supplier"}
          value={getValue(this.props.values, "supplier")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"name"}
          value={getValue(this.props.values, "name")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"rfc"}
          value={getValue(this.props.values, "rfc")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"birth"}
          value={getValue(this.props.values, "birth")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"license"}
          value={getValue(this.props.values, "license")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"emailAddress"}
          value={getValue(this.props.values, "emailAddress")}
        />
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"external"}
          value={getValue(this.props.values, "external")}
        />
        <Divider orientation="left">Información opcional</Divider>
        <AutoInput
          form={this.props.form}
          model={"driver"}
          attribute={"phone"}
          value={getValue(this.props.values, "phone")}
        />
        <Row gutter={10}>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"visa"}
              value={getValue(this.props.values, "visa")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"visaExpiration"}
              value={getValue(this.props.values, "visaExpiration")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"fast"}
              value={getValue(this.props.values, "fast")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"fastExpiration"}
              value={getValue(this.props.values, "fastExpiration")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"licenseType"}
              value={getValue(this.props.values, "licenseType")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"driver"}
              attribute={"licenseExpiration"}
              value={getValue(this.props.values, "licenseExpiration")}
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default withValues(Driver);



// WEBPACK FOOTER //
// ./src/forms/Driver.js